import * as React from 'react';
import { Footer } from '../common/Footer';
import { Responsive } from 'semantic-ui-react';
import DesktopMenu from "./DesktopMenu";
import MobileMenu from './MobileMenu';

interface Props {
  id: string;
  activeMenu: string;
}

interface State {
}

const responsiveStyles: React.CSSProperties = { display: "flex", minHeight: "100vh", flexDirection: "column" }

export class StandardPageLayout extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { id, children, activeMenu } = this.props

    return <React.Fragment >

      <Responsive id={id} minWidth={650} style={responsiveStyles}>
        <DesktopMenu fixed={true} activeMenu={activeMenu} />
        <div style={{ marginTop: 50, flex: 1 }}>
          {children}
        </div>
        <Footer />
      </Responsive>

      <Responsive id={id} maxWidth={650} style={responsiveStyles}>
        <MobileMenu fixed={true} activeMenu={activeMenu} />
        <div style={{ marginTop: 50, flex: 1 }}>
          {children}
        </div>
        <Footer />
      </Responsive>

    </React.Fragment>

  }
}


// WEBPACK FOOTER //
// ./src/common/StandardPageLayout.tsx